const singproGoods = {
  state: {
    obj: null
  },

  mutations: {
    SET_OBJ: (state, obj) => {
      state.obj = obj;
    }
  },

  actions: {}
};

export default singproGoods;



// WEBPACK FOOTER //
// ./src/store/modules/singproGoods.js